export default __webpack_public_path__ + "static/media/accuterra_outdoors_imperial.d7292102.png";